import { PlaycastEnvironmentEnum } from '@playcastdotio/CoreTypes';
import cfg from './config.json';

const CONFIG = {
  VERSION: cfg?.VERSION ?? '0.0.1-local',
  ENVIRONMENT: (cfg?.ENVIRONMENT as PlaycastEnvironmentEnum) ?? ('development' as PlaycastEnvironmentEnum),
  API_BASE_URL: cfg?.API_BASE_URL ?? 'http://localhost:3030/',
  REALTIME_API_WEBSOCKET_URL: cfg?.REALTIME_API_WEBSOCKET_URL ?? 'http://localhost:3210/ws',
  REALTIME_API_BASE_URL: cfg?.REALTIME_API_BASE_URL ?? 'http://localhost:3000/',
  METRICS_API_BASE_URL: cfg?.METRICS_API_BASE_URL ?? 'http://localhost:3031/',
  PHASE: 'beta',
  CLERK_PUBLIC_KEY: cfg?.CLERK_PUBLIC_KEY ?? '',
  GA_TRACKING_ID: cfg?.GA_TRACKING_ID ?? '',
  USE_EXPERIMENTAL: cfg?.USE_EXPERIMENTAL ?? false,
};

export default CONFIG;

export const VERSION = CONFIG.VERSION;
export const ENVIRONMENT = CONFIG.ENVIRONMENT;
